import React from "react";
import { WifiOff } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useOnlineStatus } from "@/hooks/useOnlineStatus";

/**
 * Sticky red banner shown at the top of the app when the browser reports
 * no network. Lets the user know that summarization / uploads will fail
 * until connectivity is restored, and reassures them their app still works
 * for reading the pages already loaded.
 */
export function OfflineBanner() {
  const { t } = useTranslation();
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div
      role="status"
      data-testid="offline-banner"
      className="w-full bg-[#002FA7] text-white px-4 py-2 flex items-center justify-center gap-2 border-b border-[#B31E00] no-print"
    >
      <WifiOff className="w-4 h-4 shrink-0" />
      <span className="font-mono uppercase tracking-[0.14em] text-[11px] text-center">
        {t("offline.banner")}
      </span>
    </div>
  );
}

export default OfflineBanner;
